import { ModalBody, ModalHeader } from '@99designs/common/components/Modal';
import React from 'react';
import { DrawerOverlay } from './DrawerOverlay';

interface Props {
    heading: React.ReactNode;
    children: React.ReactNode;
    showing: boolean;
    onDismiss?: () => void;
}

const ConfirmationModal = ({ heading, showing, onDismiss, children }: Props) => (
    <DrawerOverlay showing={showing} onClose={onDismiss} variations={['center']}>
        <ModalHeader>
            <div className="heading--with-divider heading--h3">{heading}</div>
        </ModalHeader>
        <ModalBody>{children}</ModalBody>
    </DrawerOverlay>
);

export default ConfirmationModal;
